import axios from "../../packages/axios";

function isVerifiedUser(user) {
 return Number(user?.status) === 1;
}

function clearSession(commit) {
 localStorage.removeItem("access_token");
 commit("SET_USER", {});
 commit("SET_AUTHENTICATED", false);
}

let pendingLogin = null;

export default {
 namespaced: true,
 state: {
  authenticated: false,
  user: {},
  onlineUsers: [],
 },
 getters: {
  onlineUsers: (state) => state.onlineUsers,
  authenticated(state) {
   return state.authenticated;
  },
  user(state) {
   return state.user;
  },
 },
 mutations: {
  SET_AUTHENTICATED(state, value) {
   state.authenticated = value;
  },
  SET_USER(state, value) {
   state.user = value;
  },
  SET_ONLINE_USERS(state, value) {
   state.onlineUsers = value;
  },
 },
 actions: {
  login({ commit, state }, payload = {}) {
   const token = localStorage.getItem("access_token");
   if (!token) {
    commit("SET_USER", {});
    commit("SET_AUTHENTICATED", false);
    return Promise.resolve();
   }
   const force = Boolean(payload?.force);
   if (!force && state.authenticated && isVerifiedUser(state.user)) {
    return Promise.resolve();
   }
   if (!force && pendingLogin) {
    return pendingLogin;
   }
   const request = axios
    .get("user")
    .then((res) => {
     const user = res.data?.user;
     if (!isVerifiedUser(user)) {
      clearSession(commit);
      return;
     }
     commit("SET_USER", user);
     commit("SET_AUTHENTICATED", true);
    })
    .catch(() => {
     if (!force) {
      clearSession(commit);
     }
    })
    .finally(() => {
     if (!force) {
      pendingLogin = null;
     }
    });
   if (!force) {
    pendingLogin = request;
   }
   return request;
  },
  logout({ commit }) {
   clearSession(commit);
   commit("SET_ONLINE_USERS", []);
  },
  setOnlineUsers({ commit }, data) {
   commit("SET_ONLINE_USERS", data);
  },
 },
};
